<adspt-layout [class.admin-page]="isAdminPage()" [disableLinks]="disableHeaderLinks()" [language]="language()">
    @if (impersonationId()) {
        <adspt-impersonation-banner />
    }
    @if (inValidUser()) {
        <nz-alert
            nzType="error"
            nzMessage="Ooops!"
            [nzDescription]="'common.errors.notValidUser' | translate"
            nzShowIcon
        />
    }
    <adspt-account-move-banner />
    <adspt-subscription-alert />
    <adspt-email-verification />
    <adspt-disallowed-optimization-banner />
    <router-outlet />
</adspt-layout>
